import React from "react";
import { StaticPage } from "@/components/StaticPage";

const SECTIONS = [
  ["1. Data we collect", "Email address if you subscribe to daily 7am email; birthday (DD-MM) to personalize On This Day; cookies for analytics and Google AdSense."],
  ["2. How we use it", "To send your daily email, to show you events for your birthday, to improve our Coincidence Engine and horoscope. We never sell your email."],
  ["3. Cookies & AdSense", "We use Google AdSense to show ads. Google may use cookies to personalize ads. You can opt out via https://adssettings.google.com. We also use essential cookies for login and preferences."],
  ["4. Your rights (GDPR)", "You can request deletion of your email/birthday data at any time via hello@oddlytrue.com. You can unsubscribe via link in every email."],
  ["5. Contact", "Data controller: OddlyTrue, hello@oddlytrue.com"],
];

export default function Privacy() {
  return (
    <StaticPage title="Privacy Policy" testid="privacy-page">
      <p className="text-[12px] text-[#9ca3af] mt-2">Last updated: 25 September 2026</p>
      <div className="mt-8 bg-white border border-[#e5e7eb] rounded-2xl p-8 shadow-sm space-y-6 text-[14px] leading-[1.7] text-[#333]">
        <p>At OddlyTrue, we take privacy seriously. This policy explains what we collect and why.</p>
        {SECTIONS.map(([h, body]) => (
          <div key={h}>
            <h3 className="font-bold text-ink">{h}</h3>
            <p className="mt-1">{body}</p>
          </div>
        ))}
        <p className="text-[11px] text-[#9ca3af] pt-4 border-t border-[#e5e7eb] mt-6">© {new Date().getFullYear()} OddlyTrue • This policy is for AdSense approval and does not constitute legal advice.</p>
      </div>
    </StaticPage>
  );
}
